// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  ACCOUNT: '/account',
  CONTACT: '/contact',
  FORM: '/form',
  CHAT: '/chat',
  CAMPAIGN: '/campaign',
  SETTING: '/setting',
  CHANNEL: '/channel',
  TENANT: '/tenant',
  TICKET: '/ticket',
  REPORT: '/report',
  CSAT: '/csat',
  PROFILE: '/profile',
  PAYMENT: '/payment',
  LINETEMPLATE: '/linetemplate',
  AUTOMATION: '/automation',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',

  payment: {
    callback: `${ROOTS.PAYMENT}/callback`,
  },
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    verify: `${ROOTS.AUTH}/verify`,
    updatePassword: `${ROOTS.AUTH}/update-password`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
    // amplify: {
    //   signIn: `${ROOTS.AUTH}/amplify/sign-in`,
    //   verify: `${ROOTS.AUTH}/amplify/verify`,
    //   signUp: `${ROOTS.AUTH}/amplify/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    // },
    // jwt: {
    //   signIn: `${ROOTS.AUTH}/sign-in`,
    //   signUp: `${ROOTS.AUTH}/sign-up`,
    // },
    // firebase: {
    //   signIn: `${ROOTS.AUTH}/firebase/sign-in`,
    //   verify: `${ROOTS.AUTH}/firebase/verify`,
    //   signUp: `${ROOTS.AUTH}/firebase/sign-up`,
    //   resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    // },
    // auth0: {
    //   signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    // },
    // supabase: {
    //   signIn: `${ROOTS.AUTH}/supabase/sign-in`,
    //   verify: `${ROOTS.AUTH}/supabase/verify`,
    //   signUp: `${ROOTS.AUTH}/supabase/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    // },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  // linetemplate: {
  //   root: ROOTS.LINETEMPLATE,
  //   list: `${ROOTS.LINETEMPLATE}/add`,
  //   edit: (id: string) => `${ROOTS.LINETEMPLATE}/${id}/edit`,
  // },
  contact: {
    root: `${ROOTS.CONTACT}`,
    list: `${ROOTS.CONTACT}/list`,
    details: (id: string) => `${ROOTS.CONTACT}/${id}/details`,
  },
  account: {
    root: `${ROOTS.ACCOUNT}`,
    list: `${ROOTS.ACCOUNT}/list`,
    details: (id: string) => `${ROOTS.ACCOUNT}/${id}/details`,
  },
  form: {
    root: `${ROOTS.FORM}`,
  },
  campaign: {
    root: `${ROOTS.CAMPAIGN}`,
    step: `${ROOTS.CAMPAIGN}/step`,
    details: (id: string) => `${ROOTS.CAMPAIGN}/${id}/details`,
  },
  channel: {
    root: `${ROOTS.CHANNEL}`,
    step: `${ROOTS.CHANNEL}/step`,
    edit: (id: string) => `${ROOTS.CHANNEL}/${id}/edit`,
  },
  chat: {
    root: `${ROOTS.CHAT}`,
    all: `${ROOTS.CHAT}/all`,
    mine: `${ROOTS.CHAT}/mine`,
    unassigned: `${ROOTS.CHAT}/unassigned`,
    whatsapp: `${ROOTS.CHAT}/whatsapp`,
    email: `${ROOTS.CHAT}/email`,
    voice: `${ROOTS.CHAT}/voice`,
    'live-chat': `${ROOTS.CHAT}/live-chat`,
    instagram: `${ROOTS.CHAT}/instagram`,
    messenger: `${ROOTS.CHAT}/messenger`,
    line: `${ROOTS.CHAT}/line`,
    sms: `${ROOTS.CHAT}/sms`,
    telegram: `${ROOTS.CHAT}/telegram`,
    teams: `${ROOTS.CHAT}/teams`,
  },
  setting: {
    root: `${ROOTS.SETTING}`,
    organization: `${ROOTS.SETTING}/organization`,
    user: {
      root: `${ROOTS.SETTING}/user`,
      details: (id: string) => `${ROOTS.SETTING}/user/${id}/details`,
    },
    // teams: `${ROOTS.SETTING}/teams`,
    teams: {
      root: `${ROOTS.SETTING}/teams`,
      details: (id: string) => `${ROOTS.SETTING}/teams/${id}/details`,
    },
    'custom-labels': `${ROOTS.SETTING}/custom-labels`,
    template: `${ROOTS.SETTING}/template`,
    'whatsapp-template': {
      root: `${ROOTS.SETTING}/whatsapp-template`,
      add: `${ROOTS.SETTING}/whatsapp-template/add`,
      createFlow: `${ROOTS.SETTING}/whatsapp-template/add/flow`,
    },

    'did-manage': `${ROOTS.SETTING}/did-manage`,
    billing: {
      root: `${ROOTS.SETTING}/billing`,
      details: (id: string) => `${ROOTS.SETTING}/billing/${id}/Invoice`,
    },
    webhook: `${ROOTS.SETTING}/webhook`,
    'custom-fields': `${ROOTS.SETTING}/custom-fields`,
    discount: `${ROOTS.SETTING}/discount`,
    lifecycle: `${ROOTS.SETTING}/lifecycle`,
    permissions: `${ROOTS.SETTING}/permissions`,
    snippets: `${ROOTS.SETTING}/snippets`,
    lineTemplate: {
      root: `${ROOTS.SETTING}/lineTemplate`,
      list: `${ROOTS.SETTING}/lineTemplate/add`,
      edit: (id: string) => `${ROOTS.SETTING}/lineTemplate/${id}/edit`,
    },
    auditLog: {
      root: `${ROOTS.SETTING}/audit-log`,
      details: (auditId: string) => `${ROOTS.SETTING}/audit-log/details/${auditId}`,
    },
    channelFeatureFlags: `${ROOTS.SETTING}/channel-feature-flags`,
    'ai-settings': `${ROOTS.SETTING}/ai-settings`,
    aiUsage: `${ROOTS.SETTING}/ai-usage`,
    autoAssignRouting: `${ROOTS.SETTING}/auto-assign-routing`,
    chatbots: {
      root: `${ROOTS.SETTING}/chatbots`,
      new: `${ROOTS.SETTING}/chatbots/new`,
      edit: (id: string) => `${ROOTS.SETTING}/chatbots/${id}/edit`,
    },
    voicebots: {
      root: `${ROOTS.SETTING}/voicebots`,
      new: `${ROOTS.SETTING}/voicebots/new`,
      edit: (id: string) => `${ROOTS.SETTING}/voicebots/${id}/edit`,
    },
    calendar: {
      root: `${ROOTS.SETTING}/calendar`,
      success: `${ROOTS.SETTING}/calendar/success`,
    },
  },
  profile: `${ROOTS.PROFILE}`,
  report: {
    root: `${ROOTS.REPORT}`,
    'call-logs': `${ROOTS.REPORT}/call-logs`,
    'message-report': `${ROOTS.REPORT}/message-report`,
    'conversation-report': `${ROOTS.REPORT}/conversation-report`,
    'support-report': `${ROOTS.REPORT}/support-report`,
  },
  csat: {
    root: `${ROOTS.CSAT}`,
    config: `${ROOTS.CSAT}/config`,
  },
  tenant: {
    root: `${ROOTS.TENANT}`,
    list: `${ROOTS.TENANT}/list`,
    details: (tenantId: string) => `${ROOTS.TENANT}/${tenantId}/details`,
    userDetails: (tenantId: string, userId: string) =>
      `${ROOTS.TENANT}/${tenantId}/details/user/${userId}/details`,
    invoice: (tenantId: string, invoiceId: string) =>
      `${ROOTS.TENANT}/${tenantId}/details/invoice/${invoiceId}/details`,
  },
  ticket: {
    root: `${ROOTS.TICKET}`,
    list: `${ROOTS.TICKET}/list`,
    details: (id: string) => `${ROOTS.TICKET}/${id}/details`,
  },
  automation: {
    root: `${ROOTS.AUTOMATION}`,
    workflows: {
      root: `${ROOTS.AUTOMATION}/workflows`,
      new: `${ROOTS.AUTOMATION}/workflows/new`,
      edit: (id: string) => `${ROOTS.AUTOMATION}/workflows/${id}/edit`,
    },
    agents: {
      root: `${ROOTS.AUTOMATION}/agents`,
      new: `${ROOTS.AUTOMATION}/agents/new`,
      detail: (id: string) => `${ROOTS.AUTOMATION}/agents/${id}`,
      analytics: `${ROOTS.AUTOMATION}/agents/analytics`,
      uiDemo: `${ROOTS.AUTOMATION}/agents/ui-demo`,
      learningQueue: `${ROOTS.AUTOMATION}/agents/learning-queue`,
      knowledgeGaps: `${ROOTS.AUTOMATION}/agents/knowledge-gaps`,
    },
  },
};
